/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Avatar1/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFormat from 'Data/format.js'
import Avatar from 'DesignSystem/Avatar/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Avatar1({
  children,
  viewPath = "/DesignSystem/DataVaxiomRelationshipsItem/Avatar",
  presignedUrl
  
}) {
let relationshipFromPersonRecordValueData = fromData.useDataFormat({ viewPath,
context: 'relationship',
path: 'from_person_record',
format: fromFormat.initials,
})
  return (<React.Fragment
>
<Avatar
  viewPath={`${viewPath}/Avatar`}
 profile_url={presignedUrl}
 data="relationship.from_person_record"
 format="/Data/format.js initials"
 initials={relationshipFromPersonRecordValueData}
/>
{children}
</React.Fragment>)
}